var m = require('mithril');
var moment = require('moment-timezone');
var uuid = require('uuid/v1');

var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var pikaday = require('../../libs/pikaday');
var formGroup = require('../../components/formGroup');
var headingElement = require('../../components/heading');
var verticalListItem = require('../../components/verticalListItem');
var selectInput = require('../../components/inputs/selectInput');
var textInput = require('../../components/inputs/textInput');
var Point = require('../../data/models/point');
var rruleModel = require('./rrule');

var eventModel = Object.create(Model);

var weekDayAbbreviations = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var monthAbbreviations = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function getRruleWeekday (date) {
  return date.day() === 0 ? 1 : date.day() - 1
}

eventModel.name = 'event';
// eventModel.url = 'event';
eventModel['@class'] = 'event';
eventModel.fields = {
  id: {
    default: uuid()
  },
  start: {
    default: moment(),
    type: 'date'
  },
  duration: {
    type: 'text',
    default: '01:00:00'
  },
  rrule: {
    default: {}
  }
};



eventModel.view = function view (ctrl) {
  return m('div', [
    m('div', [
      m(headingElement, {label: "Start"}),
      m(formGroup, [
        m(pikaday, {value: eventModel.form.start, dateFormat: 'l h:i:S K', noCalendar: true})
      ])
    ]),
    m('div', [
      m(headingElement, {label: "Duration"}),
      m(formGroup,[ 
        m(pikaday, {value: eventModel.form.duration, dateFormat: 'H:i:S', time_24hr: true, noCalendar: true})
      ])
    ]),
    // m(rruleModel)
  ])  
}


module.exports = eventModel;
